import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { MantineProvider } from '@mantine/core';
import App from './app/Apps';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
     <QueryClientProvider client={queryClient}>
      <BrowserRouter>
          <MantineProvider>
            <App />
          </MantineProvider>
      </BrowserRouter>
      </QueryClientProvider>
  </StrictMode>,
);
